import gql from 'graphql-tag'

export const mutation = gql`
  mutation deleteInspectionInspectedComponent($id: Int!) {
    record: delete_purchase_inspection_inspected_component_by_pk(id: $id) {
      id
    }
  }
`

export default mutation
